import UploadingStep from './UploadingStep';

export default UploadingStep;
